export default (theme) => ({
  container: {
    maxWidth: 1200,
    margin: "auto",
  },
  darkModeFix: {
    color: theme.palette.type === "dark" ? "white" : "black",
  },
});
